import { Controller } from "@hotwired/stimulus"
import { Sidenav } from "mdb-ui-kit"
import { useIntersection } from "stimulus-use"
import { BREAKPOINT_LG } from "../constants"

// Automatically shows sidenav on xl and hides on smaller screens
export default class extends Controller {
  connect() {
    useIntersection(this)
    this.toggleHiddenAttribute()
    window.addEventListener("resize", this.toggleHiddenAttribute.bind(this))
  }

  appear() {
    this.initSidenav()
  }

  initSidenav() {
    const instance = Sidenav.getInstance(this.element)
    if (instance) {
      instance.update()
    } else {
      new Sidenav(this.element)
    }
  }

  toggleHiddenAttribute() {
    const isXL = window.innerWidth >= BREAKPOINT_LG
    this.element.setAttribute("data-mdb-hidden", isLG ? "false" : "true")
    this.element.classList.add("custom-sidenav--active")
  }

  disconnect() {
    window.removeEventListener("resize", this.toggleHiddenAttribute.bind(this))
  }
}
